import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";
import { CLOAKED_MODE, isPathAllowed } from "@/config/cloakedMode";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import HomePage from "@/pages/HomePage";
import ChiSiamoPage from "@/pages/ChiSiamoPage";
import ChiSiamoPageB from "@/pages/ChiSiamoPageB";
import StoriaValoriPage from "@/pages/chisiamo/StoriaValoriPage";
import ImpegnoPoliticoPage from "@/pages/chisiamo/ImpegnoPoliticoPage";
import ImpegnoPoliticoDettaglioPage from "@/pages/chisiamo/ImpegnoPoliticoDettaglioPage";
import OrganismiPage from "@/pages/chisiamo/OrganismiPage";
import StatutoRegolamentiPage from "@/pages/chisiamo/StatutoRegolamentiPage";
import EntiCollegatiPage from "@/pages/chisiamo/EntiCollegatiPage";
import CatPage from "@/pages/chisiamo/CatPage";
import PromoterPage from "@/pages/chisiamo/PromoterPage";
import StrutturaTecnicaPage from "@/pages/chisiamo/StrutturaTecnicaPage";
import PartnerPage from "@/pages/chisiamo/PartnerPage";
import ImpegnoPage from "@/pages/chisiamo/ImpegnoPage";
import TrasparenzaPage from "@/pages/chisiamo/TrasparenzaPage";
import ServiziPage from "@/pages/ServiziPage";
import ConsulenzaLavoroWelfarePage from "@/pages/servizi/ConsulenzaLavoroWelfarePage";
import CheckUpTecnicoAmministrativoPage from "@/pages/servizi/CheckUpTecnicoAmministrativoPage";
import SicurezzaLavoroPage from "@/pages/servizi/SicurezzaLavoroPage";
import SorveglianzaSanitariaPage from "@/pages/servizi/SorveglianzaSanitariaPage";
import BusinessPlanPage from "@/pages/servizi/BusinessPlanPage";
import Modello231Page from "@/pages/servizi/Modello231Page";
import CertificazioniQualitaPage from "@/pages/servizi/CertificazioniQualitaPage";
import CheckUpDigitaleAIPage from "@/pages/servizi/CheckUpDigitaleAIPage";
import SicurezzaCantieriPage from "@/pages/servizi/SicurezzaCantieriPage";
import PrivacyGdprPage from "@/pages/servizi/PrivacyGdprPage";
import PatenteCreditiCantieriPage from "@/pages/servizi/PatenteCreditiCantieriPage";
import IndaginiAmbientaliPage from "@/pages/servizi/IndaginiAmbientaliPage";
import IgieneAlimentiHaccpPage from "@/pages/servizi/IgieneAlimentiHaccpPage";
import GestioneRifiutiPage from "@/pages/servizi/GestioneRifiutiPage";
import FinanzaAgevolataPage from "@/pages/servizi/FinanzaAgevolataPage";
import CertificazioneEsgPage from "@/pages/servizi/CertificazioneEsgPage";
import SpinEdiPage from "@/pages/servizi/SpinEdiPage";
import FormazioneFinanziataPage from "@/pages/servizi/FormazioneFinanziataPage";
import ApprendistatoPage from "@/pages/servizi/ApprendistatoPage";
import AggiornamentoSpecializzazionePage from "@/pages/servizi/AggiornamentoSpecializzazionePage";
import FormazioneAbilitantePage from "@/pages/servizi/FormazioneAbilitantePage";
import FormazioneObbligatoriaPage from "@/pages/servizi/FormazioneObbligatoriaPage";
import FormazionePersonalizzataPage from "@/pages/servizi/FormazionePersonalizzataPage";
import FormazioneFADPage from "@/pages/servizi/FormazioneFADPage";
import NotiziePage from "@/pages/NotiziePage";
import NotiziaDettaglioPage from "@/pages/NotiziaDettaglioPage";
import EventiPage from "@/pages/EventiPage";
import EventoDettaglioPage from "@/pages/EventoDettaglioPage";
import FormazionePage from "@/pages/FormazionePage";
import GreenBusinessPage from "@/pages/progetti/GreenBusinessPage";
import Edi50Page from "@/pages/progetti/Edi50Page";
import ProgettiPage from "@/pages/ProgettiPage";
import RicercaProgettiPage from "@/pages/RicercaProgettiPage";
import AreaLavoroWelfarePage from "@/pages/AreaLavoroWelfarePage";
import ContrattazioneCollettivaPage from "@/pages/lavoro/ContrattazioneCollettivaPage";
import ServiziLavoroPage from "@/pages/lavoro/ServiziLavoroPage";
import FlessibilitaOrganizzativaPage from "@/pages/lavoro/FlessibilitaOrganizzativaPage";
import FlessibilitaOrganizzativaProposta2Page from "@/pages/lavoro/FlessibilitaOrganizzativaProposta2Page";
import WelfareAziendalePage from "@/pages/lavoro/WelfareAziendalePage";
import TrasparenzaSalarialePage from "@/pages/lavoro/TrasparenzaSalarialePage";
import AssunzioniAgevolatePage from "@/pages/lavoro/AssunzioniAgevolatePage";
import ContenziosoLavoroPage from "@/pages/lavoro/ContenziosoLavoroPage";
import ParitaGenerePage from "@/pages/lavoro/ParitaGenerePage";
import ContattiPage from "@/pages/ContattiPage";
import LavoraConNoiPage from "@/pages/LavoraConNoiPage";
import CorsiInPartenzaPage from "@/pages/formazione/CorsiInPartenzaPage";
import CorsoDettaglioPage from "@/pages/formazione/CorsoDettaglioPage";
import IscrizioneCorsoPage from "@/pages/formazione/IscrizioneCorsoPage";
import FormazioneSottopaginaPage from "@/pages/formazione/FormazioneSottopaginaPage";
import ConvenzioniPage from "@/pages/ConvenzioniPage";
import ConvenzioneDettaglioPage from "@/pages/ConvenzioneDettaglioPage";
import ConvenzionePartnerPage from "@/pages/ConvenzionePartnerPage";
import BussolePage from "@/pages/BussolePage";
import OsservatorioEconomicoPage from "@/pages/OsservatorioEconomicoPage";
// import AreaRiservataPage from "@/pages/AreaRiservataPage"; // bozza: pagina oscurata dal frontend, ripubblicare rimuovendo il commento (import + route)
import AssociazioniPage from "@/pages/AssociazioniPage";
import AssociazioneDettaglioPage from "@/pages/AssociazioneDettaglioPage";
import DiventaSocioPage from "@/pages/DiventaSocioPage";
import AssociatiOraPage from "@/pages/AssociatiOraPage";
// import MarketplacePage from "@/pages/MarketplacePage"; // bozza: pagina oscurata dal frontend, ripubblicare rimuovendo il commento (import + route)

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: "instant" });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

// Cloaked Mode: limita la navigazione alle sole pagine in whitelist
function CloakedGuard({ children }) {
  const { pathname } = useLocation();
  if (CLOAKED_MODE && !isPathAllowed(pathname)) {
    return <Navigate to="/" replace />;
  }
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      {/* Skip to content - AGID Accessibility */}
      <a href="#main-content" className="skip-to-content" data-testid="skip-to-content">
        Vai al contenuto principale
      </a>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <div className="flex-1">
          <CloakedGuard>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/chi-siamo" element={<ChiSiamoPage />} />
            <Route path="/chi-siamo/impegno-politico" element={<ImpegnoPoliticoPage />} />
            <Route path="/chi-siamo/impegno-politico/:slug" element={<ImpegnoPoliticoDettaglioPage />} />
            <Route path="/chi-siamo-b" element={<ChiSiamoPageB />} />
            <Route path="/chi-siamo/storia-e-valori" element={<StoriaValoriPage />} />
            <Route path="/chi-siamo/organismi" element={<OrganismiPage />} />
            <Route path="/chi-siamo/statuto-e-regolamenti" element={<StatutoRegolamentiPage />} />
            <Route path="/chi-siamo/enti-collegati" element={<Navigate to="/chi-siamo/cat" replace />} />
            <Route path="/chi-siamo/enti-collegati/promo-ter" element={<PromoterPage />} />
            <Route path="/chi-siamo/cat" element={<CatPage />} />
            <Route path="/chi-siamo/partner" element={<PartnerPage />} />
            {/* /chi-siamo/rappresentanza rimossa (#0089) — contenuto trasportato nella pagina madre "Chi Siamo". Redirect di cortesia. */}
            <Route path="/chi-siamo/rappresentanza" element={<Navigate to="/chi-siamo" replace />} />
            <Route path="/chi-siamo/il-nostro-impegno" element={<ImpegnoPage />} />
            <Route path="/chi-siamo/trasparenza" element={<TrasparenzaPage />} />
            <Route path="/chi-siamo/struttura-tecnica" element={<StrutturaTecnicaPage />} />
            <Route path="/servizi" element={<ServiziPage />} />
            <Route path="/servizi/rappresentanza" element={<Navigate to="/chi-siamo" replace />} />
            <Route path="/servizi/consulenza-lavoro-welfare" element={<ConsulenzaLavoroWelfarePage />} />
            <Route path="/servizi/check-up-tecnico-amministrativo" element={<CheckUpTecnicoAmministrativoPage />} />
            <Route path="/servizi/sicurezza-lavoro" element={<SicurezzaLavoroPage />} />
            <Route path="/servizi/sorveglianza-sanitaria" element={<SorveglianzaSanitariaPage />} />
            <Route path="/servizi/business-plan" element={<BusinessPlanPage />} />
            <Route path="/servizi/modello-231" element={<Modello231Page />} />
            <Route path="/servizi/certificazioni-qualita" element={<CertificazioniQualitaPage />} />
            <Route path="/servizi/check-up-digitale-ai" element={<CheckUpDigitaleAIPage />} />
            <Route path="/servizi/sicurezza-cantieri" element={<SicurezzaCantieriPage />} />
            <Route path="/servizi/privacy-gdpr" element={<PrivacyGdprPage />} />
            <Route path="/servizi/patente-crediti-cantieri" element={<PatenteCreditiCantieriPage />} />
            <Route path="/servizi/indagini-ambientali" element={<IndaginiAmbientaliPage />} />
            <Route path="/servizi/igiene-alimenti-haccp" element={<IgieneAlimentiHaccpPage />} />
            <Route path="/servizi/gestione-rifiuti" element={<GestioneRifiutiPage />} />
            <Route path="/servizi/finanza-agevolata-bandi" element={<FinanzaAgevolataPage />} />
            <Route path="/servizi/certificazione-esg" element={<CertificazioneEsgPage />} />
            <Route path="/servizi/sportello-spin-edi" element={<SpinEdiPage />} />
            <Route path="/servizi/formazione-professionale/formazione-finanziata" element={<FormazioneFinanziataPage />} />
            <Route path="/servizi/formazione-professionale/apprendistato" element={<ApprendistatoPage />} />
            <Route path="/servizi/formazione-professionale/aggiornamento-specializzazione" element={<AggiornamentoSpecializzazionePage />} />
            <Route path="/servizi/formazione-professionale/formazione-abilitante" element={<FormazioneAbilitantePage />} />
            <Route path="/servizi/formazione-professionale/formazione-a-distanza" element={<FormazioneFADPage />} />
            <Route path="/notizie" element={<NotiziePage />} />
            <Route path="/notizie/:slug" element={<NotiziaDettaglioPage />} />
            <Route path="/eventi" element={<EventiPage />} />
            <Route path="/eventi/:slug" element={<EventoDettaglioPage />} />
            <Route path="/formazione" element={<FormazionePage />} />
            <Route path="/formazione/corsi-in-partenza" element={<CorsiInPartenzaPage />} />
            <Route path="/formazione/iscrizione-corso" element={<IscrizioneCorsoPage />} />
            <Route path="/formazione/corsi-in-partenza/:slug" element={<CorsoDettaglioPage />} />
            <Route path="/formazione/formazione-finanziata" element={<FormazioneFinanziataPage />} />
            <Route path="/formazione/apprendistato" element={<ApprendistatoPage />} />
            <Route path="/formazione/aggiornamento-specializzazione" element={<AggiornamentoSpecializzazionePage />} />
            <Route path="/formazione/formazione-abilitante" element={<FormazioneAbilitantePage />} />
            <Route path="/formazione/formazione-obbligatoria" element={<FormazioneObbligatoriaPage />} />
            <Route path="/formazione/formazione-personalizzata" element={<FormazionePersonalizzataPage />} />
            <Route path="/formazione/formazione-a-distanza" element={<FormazioneFADPage />} />
            <Route path="/formazione/:slug" element={<FormazioneSottopaginaPage />} />
            <Route path="/ricerca-e-progetti" element={<RicercaProgettiPage />} />
            <Route path="/progetti" element={<ProgettiPage />} />
            <Route path="/progetti/green-business" element={<GreenBusinessPage />} />
            <Route path="/progetti/edi-5-0" element={<Edi50Page />} />
            <Route path="/area-lavoro-welfare" element={<AreaLavoroWelfarePage />} />
            <Route path="/area-lavoro-welfare/contrattazione-collettiva" element={<ContrattazioneCollettivaPage />} />
            <Route path="/area-lavoro-welfare/servizi" element={<ServiziLavoroPage />} />
            <Route path="/area-lavoro-welfare/flessibilita-organizzativa" element={<FlessibilitaOrganizzativaProposta2Page />} />
            <Route path="/area-lavoro-welfare/flessibilita-organizzativa-proposta2" element={<FlessibilitaOrganizzativaPage />} />
            <Route path="/area-lavoro-welfare/welfare-aziendale" element={<WelfareAziendalePage />} />
            <Route path="/area-lavoro-welfare/trasparenza-salariale" element={<TrasparenzaSalarialePage />} />
            <Route path="/area-lavoro-welfare/assunzioni-agevolate" element={<AssunzioniAgevolatePage />} />
            <Route path="/area-lavoro-welfare/contenzioso-lavoro" element={<ContenziosoLavoroPage />} />
            <Route path="/area-lavoro-welfare/parita-genere" element={<ParitaGenerePage />} />
            <Route path="/contatti" element={<ContattiPage />} />
            <Route path="/contatti/lavora-con-noi" element={<LavoraConNoiPage />} />
            <Route path="/convenzioni" element={<ConvenzioniPage />} />
            <Route path="/convenzioni/:slug" element={<ConvenzioneDettaglioPage />} />
            <Route path="/convenzione-partner/:slug" element={<ConvenzionePartnerPage />} />
            <Route path="/le-bussole" element={<BussolePage />} />
            <Route path="/osservatorio-economico" element={<OsservatorioEconomicoPage />} />
            <Route path="/associazioni" element={<AssociazioniPage />} />
            <Route path="/associazioni/:id" element={<AssociazioneDettaglioPage />} />
            <Route path="/diventa-socio" element={<DiventaSocioPage />} />
            <Route path="/associati-ora" element={<AssociatiOraPage />} />
            {/* <Route path="/marketplace" element={<MarketplacePage />} /> */}
            {/* <Route path="/area-riservata" element={<AreaRiservataPage />} /> */}
          </Routes>
          </CloakedGuard>
        </div>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
